import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import DEFINE, { PATHS } from "../../../../constants/Define";
import * as Func from '../../../../helpers/functions';
import {
    PageListComponent, HeaderListComponent,
} from "../../common/component/Index";
import Ripple from '../../common/component/Ripple';
import TicketList from './TicketList';
import { get, omit } from 'lodash';

let permissionActions = [];
export default class Tickets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {}
        };
    }

    componentDidMount() {
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.TICKET);
        this.getTickets();
    }

    render() {
        const { t, ticketState } = this.props;
        const { isFetching, totalCount, totalPage, pageIndex, pageSize, tickets } = ticketState;
        const pagination = { totalCount, totalPage, pageIndex, pageSize };
        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'tickets'}
                        titleHeader={t('navigation.tickets')}
                    />
                    <TicketList
                        loading={isFetching}
                        permissions={permissionActions}
                        tickets={tickets}
                        pagination={pagination}
                        onChange={this.onTableChange}
                    />
                </PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let currentFilters = this.getCurrentFilters();
        filters = omit({ ...currentFilters, ...filters }, ['pageSize', 'pageIndex']);
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getTickets(newFilters);
    };

    getTickets(filters) {
        if (!filters) filters = this.getCurrentFilters();
        filters = omit(filters, ['totalCount', 'totalPage'])
        this.setState({ filters });
        this.props.getTickets(filters);
    }

    getCurrentFilters = (removeFields) => {
        const { ticketState } = this.props;
        const filters = omit(ticketState, [
            'tickets', 'myTickets', 'ticketAssignConfigs', 'detail', 'isFetching', 
            'isFetchingDetail', 'isFetchingTranslate', 'isFetchingConfig',
            'totalCount', 'totalPage',
        ]);
        return removeFields ? omit(filters, removeFields) : filters;
    }

}

Tickets.defaultProps = {

}
